// extracted by mini-css-extract-plugin
module.exports = {"container":"style__container__a9+OZ","left":"style__left__-Q7Pp","right":"style__right__UeFZ7","itemContainer":"style__itemContainer__bf0EQ","colorBox":"style__colorBox__-leHV"};